import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IBoardAccBill, IBoardAccSummary, IBoardChannel, IBoardIndustry, IBoardParams, IBoardReceivePayment } from '../../types/air-splitting/board';
import { EBoardSelectTime, EPaymentChannel } from '../../types/common';

const hostUrl = getHostbaseUrl();

/**
 * 看板 - 入账排行TOP5
 */
export async function queryBoardReceipt(params: IBoardParams) {
  let data = [] as IBoardReceivePayment[];

  try {
    const { code, context, message } = await Http.post<IBoardReceivePayment[]>(`${hostUrl}/pay/board/company-receipt-top`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    } else {
      data = context || [] as IBoardReceivePayment[];
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 看板 - 收款、分账分析
 */
export async function queryBoardPayment(params: IBoardParams, isAllocate: boolean) {
  let str = isAllocate ? 'allocate' : 'receipt';
  let data = [] as number[];

  try {
    const { code, context, message } = await Http.post<number[]>(`${hostUrl}/pay/board/company-${str}-info`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    } else {
      data = context || [] as number[];
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 看板 - 客户增长分析
 */
export async function queryBoardIncrease(params: IBoardParams) {
  let data = [] as number[];

  try {
    const { code, context, message } = await Http.get<number[]>(`${hostUrl}/pay/board/company-increase-info`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    } else {
      data = context || [] as number[];
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 看板 - 企业行业分析
 */
export async function queryBoardIndustry(dimension: EBoardSelectTime) {
  let data = [] as IBoardIndustry[];

  try {
    const { code, context, message } = await Http.get<IBoardIndustry[]>(`${hostUrl}/pay/board/company-industry-info`, { dimension });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    } else {
      data = context || [] as IBoardIndustry[];
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 看板 - 客户增长分析
 */
export async function queryBoardChannel() {
  let data = [] as IBoardChannel[];

  try {
    const { code, context, message } = await Http.get<IBoardChannel[]>(`${hostUrl}/pay/board/get-channel-account-info`);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    } else {
      data = context || [] as IBoardChannel[];
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 看板 - 账户账单信息汇总
 */
export async function queryBoardAccBill(channelType: EPaymentChannel) {
  let data = {} as IBoardAccBill;

  try {
    const { code, context, message } = await Http.get<IBoardAccBill>(`${hostUrl}/pay/board/get-account-bill-info`, { channelType });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    } else {
      data = context || {} as IBoardAccBill;
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 看板 - 账户账单信息汇总(平台)
 */
export async function queryBoardBillSummary(dimension: EBoardSelectTime) {
  let data = {} as IBoardAccSummary;

  try {
    const { code, context, message } = await Http.get<IBoardAccSummary>(`${hostUrl}/pay/board/get-account-bill-summary`, { dimension });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    } else {
      data = context || {} as IBoardAccSummary;
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}